import { createSelector } from "@reduxjs/toolkit";

import type { NautilusDesignerState } from "../nautilusState.ts";

export const nodeDesignsStateSelector = (state: Pick<NautilusDesignerState, "nodeDesigns">) => state.nodeDesigns;

export const nodeParentIdByChildIdSelector = createSelector(
  [nodeDesignsStateSelector],
  (state) => state.parentIdByChildId,
);
